import React from "react";
import { t } from "../../../../utils/i18n";

const DelistOffersModal = ({ viewType, closeModal}) => {

  const handleReload = () => {
    window.location.reload();
  }

  return (
    <div
      className="modal-delistoffers-alert-cont"
      tabIndex="-1"
      aria-hidden="true"
      aria-labelledby="delistOffers"
    >
      <div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          onClick={closeModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <h5 className="delistoffer-modal-title">
          <i className="fas fa-check-circle"></i>
          <span>{t("p2p.delist_modal.title")}</span>
        </h5>
        {viewType === "default" && (
          <div className="delistoffers-modal-notice" data-controller="clipboard">
            {t("p2p.delist_modal.notice")}
          </div>
        )}
        {viewType === "listUserOffers" && (
          <div className="delistoffers-modal-notice" data-controller="clipboard">
            {t("p2p.delist_modal.notice")}
          </div>
        )}
        <div className="delistoffer-modal-buttons-section">
          <button
            type="button"
            className="delistoffer-modal-tradeaction-proceedbtn"
            onClick={handleReload}
          >
            {t("p2p.common.okay")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DelistOffersModal;
